import address from './address';

const contact = `
    ${address}
    firstName
    lastName
    emailAddress
    phoneNumber
`;

export default contact;
